import { Field, Label, Radio, RadioGroup } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';

interface FormFieldRadioProps {
    field: FormFieldDto;
}

export function FormFieldRadio({ field }: FormFieldRadioProps) {
    return (
        <div className="md:col-span-2">
            <RadioGroup name={field.name} defaultValue={field.options?.defaultValue}>
                {field.choices?.map((choice) => (
                    <Field className="form-radio-field" key={choice.value}>
                        <Radio value={choice.value} className="form-radio" />
                        <Label>{choice.label}</Label>
                    </Field>
                ))}
            </RadioGroup>
        </div>
    );
}
